import { IndustryDetailPage } from "@/features/learning-content/pages/IndustryDetail";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

const IndustryDetail: FC = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <IndustryDetailPage />
      </Box>
    </Stack>
  );
};

export default IndustryDetail;
